<template>
    <div>
        <div class="fisthang">
            <el-form :inline="true" class="demo-form-inline" size="mini">
                <!-- <el-form-item label="组织机构" >
                    <orgListSelect orgType="1" v-model="orgid" :on-success="onSuccess" />
                </el-form-item>-->
                <el-form-item label="日期" >
                    <el-date-picker
                        v-model="time"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="getData">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="reset()">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="listBox-item">
            <!-- 表格盒子 -->
            <div class="table_card">
                <el-table
                    :data="tableData"
                    :header-cell-style="{ background: '#f8fafa' }"
                    size="small"
                    border
                    align="center"
                    current-row-key
                    highlight-current-row
                >
                    <el-table-column label="序号" type="index" width="50"></el-table-column>
                    <el-table-column align="center" prop="orgName" label="组织机构"></el-table-column>
                    <el-table-column align="center" prop="attendanceNum" label="应出勤(人*次)"></el-table-column>
                    <el-table-column align="center" prop="normalAttendanceNum" label="正常考勤(人*次)"></el-table-column>
                    <el-table-column align="center" prop="noAttendanceNum" label="缺勤(人*次)">
                        <!-- <template
                            slot-scope="scope"
                        >{{scope.row.attendanceNum - scope.row.normalAttendanceNum - scope.row.abnormalAttendanceNum}}</template> -->
                    </el-table-column>
                    <el-table-column align="center" prop="abnormalAttendanceNum" label="异常考勤(人*次)"></el-table-column>
                    <el-table-column align="center" prop="AttendanceRate" label="考勤率">
                        <!-- <template
                            slot-scope="scope"
                        >{{(scope.row.normalAttendanceNum/scope.row.attendanceNum).toFixed(2)}}%</template> -->
                    </el-table-column>
                    <el-table-column align="center" label="操作" width="100" fixed="right">
                        <template slot-scope="scope">
                            <el-tooltip
                                class="item"
                                effect="light"
                                content="查看"
                                placement="top-start"
                            >
                                <button
                                    class="iconfont icon-chakan tabBtn"
                                    @click="getwgList(scope.row)"
                                ></button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <el-dialog
            :append-to-body="true"
            :title="list.name+'考勤列表'"
            :visible.sync="list.visible"
            width="1200px"
        >
            <attendanceListry :gridId="list.gridId" v-if="list.off"></attendanceListry>
        </el-dialog>
    </div>
</template>

<script>
import orgListSelect from "@/component/orgListSelect/index.vue";
import attendanceListry from "./attendanceListry.vue";
export default {
    components: { orgListSelect, attendanceListry },
    props: ["communityId"],
    data() {
        return {
            orgid: [],
            tableData: [],
            time: "",
            list: {
                visible: false,
                off: true,
                gridId: "",
                name: ""
            }
        };
    },
    methods: {
        onSuccess(info) {
            // this.orgid = info.value;
            // this.getUser(info.value);
        },

        getData() {
            this.$post(
                "/admin/attendanceRecord/info/attendanceRecordStatisticsByGrid",
                {
                    communityId: this.communityId,
                    startTime: this.time[0] ? this.time[0] : "",
                    endTime: this.time[1] ? this.time[1] : ""
                }
            ).then(res => {
                res.content.map((item,index)=>{
                    if(item.orgName == null){
                        res.content.splice(index,1)
                        return
                    }
                    let num = (res.content[0].normalAttendanceNum / res.content[0].attendanceNum * 100).toFixed(1) + '%'
                    this.$set(item,'AttendanceRate',num)
                })
                this.tableData = res.content;
            });
        },
        //重置日期
        reset:function(){
            this.time = ""
            this.getData()
        },
        getwgList(row) {
            this.list.visible = true;
            this.list.gridId = row.gridId;
            this.list.name = row.orgName;
            this.list.off = false;
            this.$nextTick(_ => {
                this.list.off = true;
            });
        }
    },
    mounted() {
        this.getData();
    },
    created() {}
};
</script>

<style lang="less" scoped>
</style>
